import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  "data-testid": "cluster-manager-list-explore",
  disabled: true,
  class: "btn btn-sm role-secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Banner = _resolveComponent("Banner")!
  const _component_PaginatedResourceTable = _resolveComponent("PaginatedResourceTable")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Masthead = _resolveComponent("Masthead")!
  const _component_MachineSummaryGraph = _resolveComponent("MachineSummaryGraph")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($options.hiddenHarvesterCount)
      ? (_openBlock(), _createBlock(_component_Banner, {
          key: 0,
          color: "info",
          label: _ctx.t('cluster.harvester.clusterWarning', {count: $options.hiddenHarvesterCount} )
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    ($options.isExplorer)
      ? (_openBlock(), _createBlock(_component_PaginatedResourceTable, {
          key: 1,
          schema: $data.provClusterSchema,
          "local-filter": $options.filterProvRowsLocal,
          "api-filter": $options.filterProvRowsApi
        }, null, 8, ["schema", "local-filter", "api-filter"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_Masthead, {
            schema: $data.provClusterSchema,
            resource: $data.provClusterSchema.id,
            "create-location": $options.createLocation,
            "component-testid": "cluster-manager-list"
          }, _createSlots({ _: 2 }, [
            ($options.canImport)
              ? {
                  name: "extraActions",
                  fn: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: $options.importLocation,
                      class: "btn role-primary mr-10",
                      "data-testid": "cluster-manager-list-import"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('cluster.importAction')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["schema", "resource", "create-location"]),
          _cache[1] || (_cache[1] = _createTextVNode()),
          _createVNode(_component_PaginatedResourceTable, {
            schema: $data.mgmtClusterSchema,
            headers: $data.headers,
            "pagination-headers": $data.paginationHeaders,
            context: $data.paginationContext,
            "use-query-params-for-simple-filtering": true,
            "local-filter": $options.filterRowsLocal,
            "api-filter": $options.filterRowsApi,
            "fetch-secondary-resources": $options.fetchSecondaryResources,
            "fetch-page-secondary-resources": $options.fetchPageSecondaryResources,
            groupable: $options.nonStandardWorkspace,
            namespaced: true,
            "data-testid": 'cluster-list'
          }, {
            "cell:summary": _withCtx(({row}) => [
              (!row.stateParts.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row.statusInfo.nodeCount || 0), 1))
                : (_openBlock(), _createBlock(_component_MachineSummaryGraph, {
                    key: 1,
                    row: row
                  }, null, 8, ["row"]))
            ]),
            "cell:explorer": _withCtx(({row}) => [
              (row.canExplore)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    "data-testid": "cluster-manager-list-explore-management",
                    class: "btn btn-sm role-secondary",
                    to: {name: 'c-cluster', params: {cluster: row.id}}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('cluster.explore')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createElementBlock("button", _hoisted_2, _toDisplayString(_ctx.t('cluster.explore')), 1))
            ]),
            _: 1
          }, 8, ["schema", "headers", "pagination-headers", "context", "local-filter", "api-filter", "fetch-secondary-resources", "fetch-page-secondary-resources", "groupable"])
        ], 64))
  ]))
}